export const kTopBarHeight = '56px'
export const kViewPadding = { base: 3, sm: 4, md: 6 }

export const kOptionSlideInTransition = (delay = 0) => ({
  duration: 0.5,
  delay: 0.05 * delay,
  ease: [0.43, 0.13, 0.23, 1],
})

export const kGlobalLayoutWidth = 1160
export const kGlobalLayoutMinWidth = 768
export const kGlobalLayoutWidthNarrow = 480

export const kMobileIconSize = '20px'

export const kNavBarHeight = '54px'
export const kNavBarHeightMobile = '56px'
export const kTabBarHeightMobile = '66px'
export const kTabBarTopPadding = '90px'

export const kiOSBottomPadding = 6
